module.exports = __webpack_public_path__ + "img/mail.5cdc961.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/mail.svg
// module id = ./assets/mail.svg
// module chunks = 13